"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("@nestjsx/util");

var qs_1 = require("qs");

var request_query_validator_1 = require("./request-query.validator");

var RequestQueryBuilder = /*#__PURE__*/function () {
  function RequestQueryBuilder() {
    _classCallCheck(this, RequestQueryBuilder);

    this.paramNames = {};
    this.queryObject = {};
    this.setParamNames();
  }

  _createClass(RequestQueryBuilder, [{
    key: "options",
    get: function get() {
      return RequestQueryBuilder._options;
    }
  }, {
    key: "setParamNames",
    value: function setParamNames() {
      var _this = this;

      Object.keys(RequestQueryBuilder._options.paramNamesMap).forEach(function (key) {
        var name = RequestQueryBuilder._options.paramNamesMap[key];
        _this.paramNames[key] = util_1.isString(name) ? name : name[0];
      });
    }
  }, {
    key: "query",
    value: function query() {
      var encode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.queryObject[this.paramNames.search]) {
        this.queryObject[this.paramNames.filter] = undefined;
        this.queryObject[this.paramNames.or] = undefined;
      }

      this.queryString = qs_1.stringify(this.queryObject, {
        encode: encode
      });
      return this.queryString;
    }
  }, {
    key: "select",
    value: function select(fields) {
      if (util_1.isArrayFull(fields)) {
        request_query_validator_1.validateFields(fields);
        this.queryObject[this.paramNames.fields] = fields.join(this.options.delimStr);
      }

      return this;
    }
  }, {
    key: "search",
    value: function search(s) {
      if (!util_1.isNil(s) && util_1.isObject(s)) {
        this.queryObject[this.paramNames.search] = JSON.stringify(s);
      }

      return this;
    }
  }, {
    key: "setFilter",
    value: function setFilter(f) {
      this.setCondition(f, 'filter');
      return this;
    }
  }, {
    key: "setOr",
    value: function setOr(f) {
      this.setCondition(f, 'or');
      return this;
    }
  }, {
    key: "setJoin",
    value: function setJoin(j) {
      var _this2 = this;

      if (!util_1.isNil(j)) {
        var param = this.checkQueryObjectParam('join', []);
        this.queryObject[param] = [].concat(_toConsumableArray(this.queryObject[param]), _toConsumableArray(Array.isArray(j) && !util_1.isString(j[0]) ? j.map(function (o) {
          return _this2.addJoin(o);
        }) : [this.addJoin(j)]));
      }

      return this;
    }
  }, {
    key: "sortBy",
    value: function sortBy(s) {
      var _this3 = this;

      if (!util_1.isNil(s)) {
        var param = this.checkQueryObjectParam('sort', []);
        this.queryObject[param] = [].concat(_toConsumableArray(this.queryObject[param]), _toConsumableArray(Array.isArray(s) && !util_1.isString(s[0]) ? s.map(function (o) {
          return _this3.addSortBy(o);
        }) : [this.addSortBy(s)]));
      }

      return this;
    }
  }, {
    key: "setLimit",
    value: function setLimit(n) {
      this.setNumeric(n, 'limit');
      return this;
    }
  }, {
    key: "setOffset",
    value: function setOffset(n) {
      this.setNumeric(n, 'offset');
      return this;
    }
  }, {
    key: "setPage",
    value: function setPage(n) {
      this.setNumeric(n, 'page');
      return this;
    }
  }, {
    key: "resetCache",
    value: function resetCache() {
      this.setNumeric(0, 'cache');
      return this;
    }
  }, {
    key: "setIncludeDeleted",
    value: function setIncludeDeleted(n) {
      this.setNumeric(n, 'includeDeleted');
      return this;
    }
  }, {
    key: "cond",
    value: function cond(f) {
      var _cond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'search';

      var filter = Array.isArray(f) ? {
        field: f[0],
        operator: f[1],
        value: f[2]
      } : f;
      request_query_validator_1.validateCondition(filter, _cond);
      var d = this.options.delim;
      return filter.field + d + filter.operator + (util_1.hasValue(filter.value) ? d + filter.value : '');
    }
  }, {
    key: "addJoin",
    value: function addJoin(j) {
      var join = Array.isArray(j) ? {
        field: j[0],
        select: j[1]
      } : j;
      request_query_validator_1.validateJoin(join);
      var d = this.options.delim;
      var ds = this.options.delimStr;
      return join.field + (util_1.isArrayFull(join.select) ? d + join.select.join(ds) : '');
    }
  }, {
    key: "addSortBy",
    value: function addSortBy(s) {
      var sort = Array.isArray(s) ? {
        field: s[0],
        order: s[1]
      } : s;
      request_query_validator_1.validateSort(sort);
      var ds = this.options.delimStr;
      return sort.field + ds + sort.order;
    }
  }, {
    key: "createFromParams",
    value: function createFromParams(params) {
      this.select(params.fields);
      this.search(params.search);
      this.setFilter(params.filter);
      this.setOr(params.or);
      this.setJoin(params.join);
      this.setLimit(params.limit);
      this.setOffset(params.offset);
      this.setPage(params.page);
      this.sortBy(params.sort);

      if (params.resetCache) {
        this.resetCache();
      }

      this.setIncludeDeleted(params.includeDeleted);
      return this;
    }
  }, {
    key: "checkQueryObjectParam",
    value: function checkQueryObjectParam(cond, defaults) {
      var param = this.paramNames[cond];

      if (util_1.isNil(this.queryObject[param]) && !util_1.isUndefined(defaults)) {
        this.queryObject[param] = defaults;
      }

      return param;
    }
  }, {
    key: "setCondition",
    value: function setCondition(f, cond) {
      var _this4 = this;

      if (!util_1.isNil(f)) {
        var param = this.checkQueryObjectParam(cond, []);
        this.queryObject[param] = [].concat(_toConsumableArray(this.queryObject[param]), _toConsumableArray(Array.isArray(f) && !util_1.isString(f[0]) ? f.map(function (o) {
          return _this4.cond(o, cond);
        }) : [this.cond(f, cond)]));
      }
    }
  }, {
    key: "setNumeric",
    value: function setNumeric(n, cond) {
      if (!util_1.isNil(n)) {
        request_query_validator_1.validateNumeric(n, cond);
        this.queryObject[this.paramNames[cond]] = n;
      }
    }
  }], [{
    key: "setOptions",
    value: function setOptions(options) {
      RequestQueryBuilder._options = _objectSpread(_objectSpread(_objectSpread({}, RequestQueryBuilder._options), options), {}, {
        paramNamesMap: _objectSpread(_objectSpread({}, RequestQueryBuilder._options.paramNamesMap), options.paramNamesMap ? options.paramNamesMap : {})
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return RequestQueryBuilder._options;
    }
  }, {
    key: "create",
    value: function create(params) {
      var qb = new RequestQueryBuilder();
      return util_1.isObject(params) ? qb.createFromParams(params) : qb;
    }
  }]);

  return RequestQueryBuilder;
}();

exports.RequestQueryBuilder = RequestQueryBuilder;
RequestQueryBuilder._options = {
  delim: '||',
  delimStr: ',',
  paramNamesMap: {
    fields: ['fields', 'select'],
    search: 's',
    filter: 'filter',
    or: 'or',
    join: 'join',
    sort: 'sort',
    limit: ['limit', 'per_page'],
    offset: 'offset',
    page: 'page',
    cache: 'cache',
    includeDeleted: 'include_deleted'
  }
};